import { render, staticRenderFns } from "./OnlineCultureSciences.vue?vue&type=template&id=3c9b3f0e&"
import script from "./OnlineCultureSciences.vue?vue&type=script&lang=ts&"
export * from "./OnlineCultureSciences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports